const reviews = [
  {
    name: "Mark S.",
    location: "Downtown Bozeman, MT",
    rating: 5,
    text: "BZN has so many great flights but you need a valid passport for international connections. Fast Passport Center got mine renewed in 5 days. No need to drive to Denver — incredible service for Bozeman travelers.",
    service: "Expedited Renewal",
  },
  {
    name: "Jennifer K.",
    location: "Belgrade, MT",
    rating: 5,
    text: "Planning a ski trip turned into a passport scramble. My agent walked me through every step and stayed on top of the status updates. Bozeman has great access to flights — now I actually have the passport to use them.",
    service: "New Passport",
  },
  {
    name: "Paul R.",
    location: "Four Corners, MT",
    rating: 5,
    text: "Used Fast Passport Center for our honeymoon trip to Europe. The process was completely stress-free — they checked all our documents, caught a small error before submission, and had everything back in 7 days.",
    service: "Family Expedited",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Bozeman Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Real customers. Real results. No Denver agency trip required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                  <p className="text-gray-400 text-xs">{r.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {r.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}